import React from "react";
import "./UserConfirmationModalView.css";

type Props = {
  title: string;
  message: string;
  subMessage: string;
  variant: "warning" | "danger" | "success";
};

export default function UserConfirmationModalView({
  title,
  message,
  subMessage,
  variant,
}: Props) {
  let icon = <></>;

  if (variant === "warning") {
    icon = (
      <svg
        width="71"
        height="71"
        viewBox="0 0 71 71"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.4998 70.0833C54.5997 70.0833 70.0832 54.5998 70.0832 35.5C70.0832 16.4001 54.5997 0.916626 35.4998 0.916626C16.4 0.916626 0.916504 16.4001 0.916504 35.5C0.916504 54.5998 16.4 70.0833 35.4998 70.0833ZM28.5832 7.83329L32.0415 42.4166H38.9582L42.4165 7.83329H28.5832ZM35.4998 63.1666C39.3198 63.1666 42.4165 60.0699 42.4165 56.25C42.4165 52.43 39.3198 49.3333 35.4998 49.3333C31.6799 49.3333 28.5832 52.43 28.5832 56.25C28.5832 60.0699 31.6799 63.1666 35.4998 63.1666Z"
          fill="#F7A246"
        />
      </svg>
    );
  }

  if (variant === "danger") {
    icon = (
      <svg
        width="71"
        height="71"
        viewBox="0 0 71 71"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M70.0832 35.5001C70.0832 54.5999 54.5997 70.0834 35.4998 70.0834C16.4 70.0834 0.916504 54.5999 0.916504 35.5001C0.916504 16.4002 16.4 0.916748 35.4998 0.916748C54.5997 0.916748 70.0832 16.4002 70.0832 35.5001ZM21.6665 56.2501L35.4998 42.4167L49.3332 56.2501L56.2498 49.3334L42.4165 35.5001L56.2498 21.6667L49.3332 14.7501L35.4998 28.5834L21.6665 14.7501L14.7498 21.6667L28.5832 35.5001L14.7498 49.3334L21.6665 56.2501Z"
          fill="#DB0000"
        />
      </svg>
    );
  }

  if (variant === "success") {
    icon = (
      <svg
        width="71"
        height="71"
        viewBox="0 0 71 71"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M35.4998 70.0837C54.5997 70.0837 70.0832 54.6002 70.0832 35.5003C70.0832 16.4005 54.5997 0.916992 35.4998 0.916992C16.4 0.916992 0.916504 16.4005 0.916504 35.5003C0.916504 54.6002 16.4 70.0837 35.4998 70.0837ZM18.2082 32.042L11.2915 38.9587L28.5832 56.2503L59.7082 25.1253L52.7915 18.2087L28.5832 42.417L18.2082 32.042Z"
          fill="#00A84C"
        />
      </svg>
    );
  }

  return (
    <div className="user-confirm-container">
      <span className="user-confirm-title">{title}</span>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gridArea: "animation",
          marginBottom: 40,
          marginTop: 41,
        }}
      >
        {icon}
      </div>
      <span className="user-confirm-message centered">{message}</span>
      <span className="user-confirm-sub-message centered">{subMessage}</span>
    </div>
  );
}
